import React, { useState, useEffect } from "react";
import SpinnerInput from "common/SpinnerInput";
import styled from "styled-components";
import useFirstTime from "common/hooks/firstTime";
import Labeled from "common/Labeled";

const doesNothing = () => {};

const splitHourMinute = (input) => {
  const [hour, minute] = input.split(":");
  return { hour: parseInt(hour, 10), minute: parseInt(minute, 10) };
};

const TimeInputWrapper = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: flex-end;
  width: 20ch !important;
  input {
    min-width: 0;
  }
  .separator {
    width: 2ch;
    text-align: center;
  }
  .spinner {
    flex: initial;
  }
`;

const format = ({ hour, minute }) =>
  `${String(hour).padStart(2, "0")}:${String(minute).padStart(2, "0")}`;

const MAX_START_HOUR = 23;

const MAX_END_HOUR = 24;

const MAX_MINUTE = 59;

// The 24th hour is midnight, so it is the only one without minutes.
const maxMinuteOf = (hour) => (hour === MAX_END_HOUR ? 0 : MAX_MINUTE);

const withMinutesInRange = ({ hour, minute }) => ({
  hour,
  minute: Math.min(minute, maxMinuteOf(hour)),
});

export const TimeInput = ({
  name,
  defaultValue = "00:00",
  onChange = doesNothing,
}) => {
  const [time, setTime] = useState(
    withMinutesInRange(splitHourMinute(defaultValue))
  );
  const isFirstTime = useFirstTime();
  const updateField = (field) => (source) => {
    const value = source.target === undefined ? source : source.target.value;
    setTime(withMinutesInRange({ ...time, [field]: parseInt(value, 10) }));
  };
  useEffect(() => {
    if (isFirstTime()) {
      return;
    }
    onChange(format(time));
  }, [time]);

  const maxHours = name === "end" ? MAX_END_HOUR : MAX_START_HOUR;
  const maxMinutes = maxMinuteOf(time.hour);
  return (
    <TimeInputWrapper className="form-line inline hour-and-minute nowrap">
      <input type="hidden" value={format(time)} name={name} />
      <SpinnerInput
        defaultValue={time.hour}
        onChange={updateField("hour")}
        size={2}
        min={0}
        max={maxHours}
        type="number"
        placeHolder={`hours (00-${maxHours})`}
      />
      <span className="separator">:</span>
      <SpinnerInput
        key={`minutes-${maxMinutes}`}
        defaultValue={time.minute}
        onChange={updateField("minute")}
        size={2}
        min={0}
        max={maxMinutes}
        type="number"
        placeHolder={
          maxMinutes === 0 ? "minutes (00)" : `minutes (00-${maxMinutes})`
        }
      />
    </TimeInputWrapper>
  );
};

export const LabeledTimeInput = ({ ...settings }) => (
  <Labeled {...settings}>
    <div className="margin-l-10">
      <TimeInput {...settings} />
    </div>
  </Labeled>
);
export default LabeledTimeInput;
